import { fetchConToken } from "../helpers/fetch";
import { Alert } from 'rsuite';
import { types } from "../types/types";
import { startFormValid, errorFormValid, finishFormValid, msgFormValid } from "./form";
import { msg_error } from "../helpers/msg_error";


export const initLoadPayments = (id = null) => {
    return async (dispatch) => {
        dispatch(startLoading());
        let resp
        if(!!id){
            resp = await fetchConToken(`pagos/${id}`);
        } else{
            resp = await fetchConToken('pagos');
        }
        const body = await resp.json();
        if(!body.ok){
            console.log(body.error_description);
            Alert.error('No se realizar la consulta de tus pagos.', 5000);
        } else {
            await dispatch( loadPayments(body.pagos, body.in_process, body.total) );
        }
        setTimeout(() => {
            dispatch(finishLoading());
        }, 750);

    }
}

const startLoading = () => ({ type: types.paymentsStartLoading })
const finishLoading = () => ({ type: types.paymentsFinishLoading })

const loadPayments = (pagos, in_process, total) => ({
    type: types.paymentsloading,
    payload: {
        pagos,
        in_process,
        total
    },
});

export const generatePagoEfectivo = (cantidad, formName, type, resetForm) => {
    return async (dispatch) => {
        await dispatch(startFormValid(formName));
        let data = `cantidad=${cantidad}`
        data += `&type=${type}`;
        const resp = await fetchConToken(`pagos/efectivo`, data, 'POST');
        const body = await resp.json();
        if(!body.ok){
            dispatch(errorFormValid(formName, msg_error(body.message)));
            Alert.error('No se pudo realizar tu pago.', 5000);
        }else {
            Alert.success('Ficha de pago generada.', 5000);
            await dispatch( addPayment(body.pago, 'in_process') );
            resetForm();
        };
        dispatch(finishFormValid(formName));
    }
}

export const generatePagoTarjeta = (cantidad, formName, { card, id: token}, deviceSessionId, usePoints, resetForm, useAuth3D) => {
    return async (dispatch) => {
        let data = `cantidad=${cantidad}`;
        data += `&token=${token}`;
        data += `&device_session_id=${deviceSessionId}`;
        data += `&use_card_points=${usePoints}`;
        data += `&use_auth_3d=${useAuth3D}`;
        // data += `&card_number=${card.card_number}`;
        // data += `&holder_name=${card.holder_name}`;
        // data += `&expiration_year=${card.expiration_year}`;
        // data += `&expiration_month=${card.expiration_month}`;
        // data += `&brand=${card.brand}`;
        // data += `&creation_date=${card.creation_date}`;
        const resp = await fetchConToken(`pagos/tarjeta`, data, 'POST');
        const body = await resp.json();
        if(!body.ok){
            if(body.message == "Fraud risk detected by anti-fraud system"){
                await dispatch(generatePagoTarjeta(cantidad, formName, { card, id: token}, deviceSessionId, usePoints, resetForm, true));
            } else{
                dispatch(errorFormValid(formName, msg_error(body.message)));
                dispatch(finishFormValid(formName));
            }
        }else {
            if(body.type === 'redirect'){
                window.location.href = body.url;
                return;
            };

            Alert.success('Pago acreditado correctamente.', 5000);
            dispatch(msgFormValid(formName, msg_error(body.message)));

            dispatch( addPayment(body.pago, 'list') );
            dispatch( addTotalPayment(body.pago.cantidad) );

            resetForm();
            dispatch(finishFormValid(formName));
        };
        
    }
}

export const asignarPago = (formName, account, invoice, atm, quantity, date, type, resetForm) => {
    return async (dispatch) => {
        await dispatch(startFormValid(formName));
        let data = `account=${account}`
        data += `&invoice=${invoice}`;
        data += `&atm=${atm}`;
        data += `&quantity=${quantity}`;
        data += `&date=${date}`;
        data += `&type=${type}`;
        const resp = await fetchConToken(`pagos/asignar`, data, 'POST');
        const body = await resp.json();
        if(!body.ok){
            dispatch(errorFormValid(formName, msg_error(body.message)));
            Alert.error('No se pudo asignar tu pago.', 5000);
        }else {
            Alert.success('Pago asignado.', 5000);
            await dispatch( addPayment(body.pago, 'list') );
            await dispatch( addTotalPayment(body.pago.cantidad) );
            resetForm();
        };
        dispatch(finishFormValid(formName));
    }
}

const addPayment = (payment, type) => ({
    type: types.paymentsAddPayment,
    payload: {
        payment,
        type
    }
});

const addTotalPayment = (amount) => ({
    type: types.paymentsAddTotal,
    payload: amount
});


export const paymentLogout = () => ({
    type: types.paymentsLogout
})